module.exports = __webpack_public_path__ + "img/SHOPPING_BAG.8e3b8324.svg";